import { RescheduleAppointmentSuccessCard } from "../components/payment-card";

export function RescheduleAppointmentBookingSuccess({ appointment_id }: { appointment_id: string }) {
  return (
    <RescheduleAppointmentSuccessCard appointment_id={appointment_id} />
  );
}
